import { render, staticRenderFns } from "./RemovableItem.vue?vue&type=template&id=f6111916&scoped=true&"
import script from "./RemovableItem.vue?vue&type=script&lang=js&"
export * from "./RemovableItem.vue?vue&type=script&lang=js&"
import style0 from "./RemovableItem.vue?vue&type=style&index=0&id=f6111916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6111916",
  null
  
)

export default component.exports